export const SET_ELEMENT_INTO_VIEW = 'intersectionObserver/SET_ELEMENT_INTO_VIEW';
